/**
 * Coach Academy Context Store
 *
 * Holds the current academy context when a coach is viewing
 * academy-scoped routes (/academy/:academySlug/coach/*).
 */

import { create } from 'zustand';
import type { Academy } from '@court-sync/shared';

interface CoachAcademyState {
    academySlug: string | null;
    academyId: string | null;
    academy: Academy | null;
    setAcademyContext: (slug: string, id: string, academy: Academy) => void;
    clearAcademyContext: () => void;
}

export const useCoachAcademyStore = create<CoachAcademyState>((set) => ({
    academySlug: null,
    academyId: null,
    academy: null,
    setAcademyContext: (slug, id, academy) => set({ academySlug: slug, academyId: id, academy }),
    clearAcademyContext: () => set({ academySlug: null, academyId: null, academy: null }),
}));
